export default function AboutComparison() {
  return (
    <section className="py-24 md:py-32 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-20">
          <div className="lg:w-[55%]">
            <h2 className="text-[28px] md:text-[36px] font-heading text-foreground-950 leading-[1.25] mb-6">
              What is <span className="italic">itaobuyspreadsheet</span>?
            </h2>
            <p className="text-[14px] md:text-[15px] text-foreground-700 leading-relaxed mb-5 max-w-[90%]">
              itaobuyspreadsheet is a structured product comparison system designed to simplify online shopping
              by organizing product data into easy-to-read spreadsheet formats. Instead of browsing endlessly,
              users can compare prices instantly, filter product categories, track product availability,
              and analyze multiple sellers at once — all from a single organized view.
            </p>
            <p className="text-[14px] md:text-[15px] text-foreground-700 leading-relaxed mb-10 max-w-[90%]">
              Built for shoppers who value efficiency, the itaobuy spreadsheet system eliminates the clutter
              of traditional e-commerce browsing and replaces it with clean, structured data that makes
              decision-making faster and more confident.
            </p>

            <div className="overflow-x-auto mb-10">
              <table className="w-full border-collapse text-left">
                <thead>
                  <tr className="bg-secondary-100">
                    <th className="px-5 py-3.5 text-[12px] font-semibold text-foreground-950 rounded-l-xl">Feature</th>
                    <th className="px-5 py-3.5 text-[12px] font-semibold text-foreground-700">Traditional Shopping</th>
                    <th className="px-5 py-3.5 text-[12px] font-semibold text-primary-700 rounded-r-xl">itaobuyspreadsheet</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-background-200">
                    <td className="px-5 py-3.5 text-[13px] text-foreground-800 font-medium">Speed</td>
                    <td className="px-5 py-3.5 text-[13px] text-foreground-600">Slow, manual browsing</td>
                    <td className="px-5 py-3.5 text-[13px] text-primary-700 font-medium">Fast, structured view</td>
                  </tr>
                  <tr className="border-b border-background-200">
                    <td className="px-5 py-3.5 text-[13px] text-foreground-800 font-medium">Price Comparison</td>
                    <td className="px-5 py-3.5 text-[13px] text-foreground-600">Manual, time-consuming</td>
                    <td className="px-5 py-3.5 text-[13px] text-primary-700 font-medium">Automated, side-by-side</td>
                  </tr>
                  <tr className="border-b border-background-200">
                    <td className="px-5 py-3.5 text-[13px] text-foreground-800 font-medium">Efficiency</td>
                    <td className="px-5 py-3.5 text-[13px] text-foreground-600">Low, scattered data</td>
                    <td className="px-5 py-3.5 text-[13px] text-primary-700 font-medium">High, centralized data</td>
                  </tr>
                  <tr>
                    <td className="px-5 py-3.5 text-[13px] text-foreground-800 font-medium">Decision Making</td>
                    <td className="px-5 py-3.5 text-[13px] text-foreground-600">Confusing, overwhelming</td>
                    <td className="px-5 py-3.5 text-[13px] text-primary-700 font-medium">Clear, structured</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 text-[14px] font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              itaobuy sheet
              <i className="ri-arrow-right-up-line text-sm"></i>
            </a>

            <div className="flex gap-16 mt-16">
              <div>
                <p className="text-[40px] md:text-[48px] font-bold text-foreground-950 font-heading">14</p>
                <p className="text-[12px] text-foreground-500 mt-1">Product Categories</p>
              </div>
              <div>
                <p className="text-[40px] md:text-[48px] font-bold text-foreground-950 font-heading">10K+</p>
                <p className="text-[12px] text-foreground-500 mt-1">Products Listed</p>
              </div>
            </div>
          </div>

          <div className="lg:w-[45%]">
            <div className="relative rounded-2xl overflow-hidden h-[520px]">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20editorial%20with%20carefully%20curated%20neutral%20toned%20clothing%20and%20leather%20accessories%20on%20clean%20warm%20cream%20surface%2C%20soft%20morning%20window%20light%2C%20professional%20product%20styling%2C%20warm%20organic%20aesthetic%2C%20high%20quality%20editorial%20photography%2C%20calm%20serene%20composition&width=900&height=1200&seq=about-visual-v4&orientation=portrait"
                alt="itaobuy spreadsheet product comparison"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute top-5 left-5">
                <span className="inline-block px-4 py-2 rounded-full bg-white/90 text-foreground-950 text-[11px] font-semibold">
                  Global Sourcing
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                <p className="text-white text-[13px] font-semibold">itaobuy.hair</p>
                <p className="text-white/70 text-[12px] mt-1">
                  Your gateway to structured product comparison
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}